<template>
  <icons-preview />
</template>

<script>
import IconsPreview from "@/components/icons-preview/icons-preview";

export default {
  components: {
    IconsPreview
  }
};
</script>
